module.exports = __webpack_public_path__ + "img/irisa.2682eee.png";